export var shape = { borderRadius: 0 };
